import { useMemo } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { ADMIN_CT_BM_NO_ACCESS } from "../../Constant";
import NoAccess from "../../components/NoAccess";
import comingSoon from "../../assets/images/coming_soon.svg";
import Button from "../../components/Button/Button";
import "./AdminCTBM.scss";

const AdminCTBM = () => {
  const navigate = useNavigate();
  const userPermissionsData: string[] = useSelector(
    (state: RootState) => state.UserProfileSlice.userPermissions,
  );

  const hasCTBMAccess = useMemo(() => {
    if (!userPermissionsData?.length) return false;
    return userPermissionsData.some((permission) =>
      ["system_admin", "system_support"].includes(permission?.toLowerCase()),
    );
  }, [userPermissionsData]);

  if (!hasCTBMAccess) {
    return (
      <NoAccess
        headerText={ADMIN_CT_BM_NO_ACCESS.HEADER}
        descriptionText={ADMIN_CT_BM_NO_ACCESS.DESCRIPTION}
        descriptionText2={ADMIN_CT_BM_NO_ACCESS.SUGGESTION}
        buttonLabel={ADMIN_CT_BM_NO_ACCESS.BUTTON_LABEL}
        onClickHandler={() => navigate("/")}
      />
    );
  }

  return (
    /* this code should be removed when the ct bm list implemented */
    <div className="admin-empty-section">
      <img src={comingSoon} alt="empty list" />
      <div>
        <p>Coming soon</p>
        <p className="suggestion-text">
          We are currently working on this module. It will be available soon.
        </p>
      </div>
      <Button
        variant="primary"
        className="admin-empty-btn"
        onClickHandler={() => navigate("/")}
        label={ADMIN_CT_BM_NO_ACCESS.BUTTON_LABEL}
      />
    </div>
  );
};
export default AdminCTBM;
